export const GET_PRODUCTS_API_REQUEST = 'GET_PRODUCTS_API_REQUEST';
export const GET_PRODUCTS_API_SUCCESS = 'GET_PRODUCTS_API_SUCCESS';
export const GET_PRODUCTS_API_ERROR = 'GET_PRODUCTS_API_ERROR';
export const GET_PRODUCT_DETAILS_API_REQUEST = 'GET_PRODUCT_DETAILS_API_REQUEST';
export const GET_PRODUCT_DETAILS_API_SUCCESS = 'GET_PRODUCT_DETAILS_API_SUCCESS';
export const GET_PRODUCT_DETAILS_API_ERROR = 'GET_PRODUCT_DETAILS_API_ERROR';
export const ALTER_PRODUCT_TYPE = 'ALTER_PRODUCT_TYPE';
